export default function translateBudgetsToProgressBarValues(
  agreedBudget,
  plannedBudget,
  totalAgreementBudget,
) {
  const overspentBudget = plannedBudget + agreedBudget - totalAgreementBudget;
  const openBudget = totalAgreementBudget - (plannedBudget + agreedBudget);
  const agreed =
    openBudget >= 0
      ? agreedBudget
      : Math.min(agreedBudget, totalAgreementBudget);
  const planned =
    openBudget >= 0
      ? plannedBudget
      : Math.max(totalAgreementBudget - agreedBudget, 0);
  const open = Math.max(0, openBudget);
  const overspent = Math.max(0, overspentBudget);
  return { agreed, planned, open, overspent };
}
